import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useWorkOrdersServiceRequestTargetTimesEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.WorkOrdersServiceRequestTargetTimes, false);

  return Boolean(isEnabled);
}
